import React from "react";

// Formación, Eventos, Recursos y Noticias repetían cada una su propio .map
// sobre las categorías, con tres estilos distintos para la píldora inactiva y
// dos tamaños diferentes. Eran cuatro filtros que hacían lo mismo y no se
// parecían entre sí.
//
// Semánticamente es un grupo de radio: se elige una categoría de entre varias.
// Antes eran botones sueltos, así que un lector de pantalla no anunciaba ni el
// conjunto ni cuál estaba activa.
export default function FilterPills({
  options,
  value,
  onChange,
  label = "Filtrar por categoría",
  className = "",
  ...rest
}) {
  if (!options || options.length < 2) return null;

  return (
    <div role="radiogroup" aria-label={label} className={`flex flex-wrap gap-2 ${className}`} {...rest}>
      {options.map(option => {
        const val = typeof option === "string" ? option : option.value;
        const text = typeof option === "string" ? option : option.label;
        const active = val === value;
        return (
          <button
            key={val}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(val)}
            style={{ borderRadius: "var(--radius-pill)" }}
            className={`px-4 py-2 text-sm font-medium border transition-[background-color,color,border-color,transform]
              duration-fast ease-out-apple active:scale-[0.97] focus-ring ${
                active
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-card text-muted-foreground border-border hover:border-primary/50 hover:text-foreground"
              }`}
          >
            {text}
          </button>
        );
      })}
    </div>
  );
}
